module.exports = __webpack_public_path__ + "img/toLocation.ce9cde20.png";